<template>
    <div :class="classes">
        <div v-if="step.event_step_command_type_id !== 3">
            <b> {{ step.event_step_command_type.name }} </b>
            <i v-if="step.display_text">"{{ step.display_text }}"</i>
            <i v-if="step.sound"> {{ step.sound.filename }}</i>
            <i v-if="step.to_event_step"> {{ step.to_event_step.order }}</i>
            <i v-if="step.advanced_visual"> {{ step.advanced_visual.name }}</i>
            <span v-if="step.zone"> to zone '{{ step.zone.name }}'</span>
        </div>
        <div v-if="step.event_step_command_type_id !== 3" class="dropdown ml-auto">
            <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" @click="handleEdit">
                    <i class="fa fa-edit fa-fw" aria-hidden="true"></i>&nbsp;Edit
                </a>
                <a class="dropdown-item" @click="handleDelete">
                    <i class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete
                </a>
            </div>
        </div>
        <div v-if="step.event_step_command_type_id === 3" class="w-100 d-flex justify-content-between">
            <span>
                <i class="fa fa-pause-circle" style="color: orange"></i>
                <b> {{ step.event_step_command_type.name }} </b>
                <i>&nbsp;for&nbsp;</i>
                <input v-model="step.sleep_duration" type="number" @keyup.enter="$event.target.blur()" @blur="$store.dispatch('addEditEventStep', { event_step: step })" />
                <i> seconds</i>
            </span>
            <div class="remove-pause-btn" @click="handleDelete">
                <i class="fa fa-trash"></i>
            </div>
        </div>
    </div>
</template>


<script>
import DragBox from '../DragBox'

export default {
    components: { DragBox },
    props: {
        step: Object,
        callback: Function
    },
    methods: {
        handleDelete() {
            this.callback('delete', this.step)
        },
        handleEdit() {
            this.callback('edit', this.step)
        }
    },
    computed: {
        classes() {
            return {
                'step-info': true,
                'pause-step': this.step.event_step_command_type_id === 3,
                'is-new': this.step.is_new ? true : false
            }
        }
    }
}
</script>

<style scoped>
.step-info>.dropdown {
    cursor: pointer;
}

.step-info {
    height: 100%;
    padding: 0.5rem;
    margin: 0.5rem 0;
    display: flex;
    align-items: center;
    outline: 1px solid #ddd;
    justify-content: space-between;
}

.step-info:hover {
    background-color: #eee;
    outline: 2px solid black;
    cursor: grab;
}

.pause-step {
    position: relative;
    outline: none;
    justify-content: center;
    margin: 1rem auto;
    width: 300px;
}

.pause-step > div {
    display: flex;
    justify-content: space-between;
}

.pause-step::before {
    content: "...";
    position: relative;
    top: -1.5rem;
    left: 50%;
    transform: rotate(90deg);
    font-size: 20px;
}

.pause-step::after {
    content: "...";
    position: relative;
    top: 1.5rem;
    right: 44%;
    transform: rotate(90deg);
    font-size: 20px;
}


.remove-pause-btn {
    display: none;
    color: #f30;
}

.pause-step:hover .remove-pause-btn,
.remove-pause-btn:hover {
    display: inline-block;
    cursor: pointer;
}

/* Hide number box controls for Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    /* Hide number box controls for Firefox */
    -moz-appearance: textfield;
    appearance: textfield;
    border: 1px solid #ccc;

    width: 2rem;
    height: 1.25rem;
    text-align: center;
}

@keyframes pulse {
    0% {
        outline: 4px solid rgba(0, 50, 100, 0.1);
        background-color:  rgba(0, 50, 100, 0.1);
    }

    50% {
        outline: 4px solid rgba(0, 50, 100, 0.4);
        background-color:  rgba(0, 50, 100, 0.4);
    }

    100% {
        outline: 4px solid rgba(0, 50, 100, 0.1);
        background-color:  rgba(0, 50, 100, 0.1);
    }
}

.is-new {
    animation-name: pulse;
    animation-duration: 2s;
    animation-delay: 0ms;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 3;
}</style>